var productVue;
setTimeout(function () { waitForVueAccessoriesProductPopup(10); }, 500);

function waitForVueAccessoriesProductPopup(vueLoadCounter) {
    if (vueLoadCounter < 0)
        return;
    if (typeof Vue === 'undefined') {
        setTimeout(function () { waitForVueAccessoriesProductPopup(--vueLoadCounter); }, 500);
        console.log('vue not loaded ' + vueLoadCounter);
        return;
    }

    Vue.filter('round', function (value, decimals) {

        if (!value) {
            value = 0;
        }
        if (!decimals) {
            decimals = 0;
        }

        value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
        return value;
    });

    Vue.filter('smcurrency', function (value, moneyFormat) {
        return Shopify.formatMoney(value * 100, moneyFormat)||"";
    });

    productVue = new Vue({
        delimiters: ['£{', '}'],
        el: '#productBox',
        data: {
            status: "",
            productData: null,
            selectedImage: "",
            activeVariant : null,
            currency : '',
            selectedVaraintId:0,
            moneyFormat: "",
            disableButton:false,
            option1SelectedVal:"",
            option2SelectedVal:"",
            option3SelectedVal:"",
        },
        methods: {
            optionChanged(event){
                setTimeout(this.updateActiveVariantFromOptions, 300)
            },
            updateActiveVariantFromOptions(){
                let v = this.productData?.product?.variants.find(x=>
                    (this.option1SelectedVal ? x.option1 === this.option1SelectedVal : true) &&
                    (this.option2SelectedVal ? x.option2 === this.option2SelectedVal : true) &&
                    (this.option3SelectedVal ? x.option3 === this.option3SelectedVal : true));
                if(v){
                    this.setActiveVariant(v);
                }
            },
            addToCartButtonClick(){
                this.disableButton = true;
                this.updateActiveVariantFromOptions();
                setTimeout(()=>AccessoriesProductPopupHelper.updateAccessoriesPopupCart(this.activeVariant), 300);
            },
            setMoneyFormat(moneyFormat){
                this.moneyFormat = moneyFormat;
            },
            setCurrency(currency){
                this.currency = currency;
            },
            setStatus(status) {
                this.status = status;
            },
            setDisableButton(disableButton){
                this.disableButton = disableButton;
            },
            setProductData(productData, variant) {
                this.productData = productData;
                if (productData) {
                    this.setActiveVariant(variant);
                    if(variant?.image_id){
                        let image = productData.product.images.find(x=> x.id === variant?.image_id);
                        if(image){
                            this.setActiveImage(image.src);
                        }else{
                            this.setActiveImage(productData.product.images[0].src);
                        }
                    }else{
                        this.setActiveImage(productData.product.images[0].src);
                    }
                } else {
                    this.setActiveImage('');
                }
            },
            setActiveVariant(variant){
                this.activeVariant = variant;
                this.option1SelectedVal = variant.option1;
                this.option2SelectedVal = variant.option2;
                this.option3SelectedVal = variant.option3;
                this.updateImageBasedOnVariant();
            },
            setActiveImage(image) {
                this.selectedImage = image;
            },
            roundToCeiling(quantity, step) {
                var modeRemainder = quantity % step;
                if (modeRemainder) {
                    return quantity - modeRemainder + step;
                }

                return quantity;
            },
            roundToFloor(quantity, step) {
                var modeRemainder = quantity % step;
                if (modeRemainder) {
                    return quantity - modeRemainder;
                }

                return quantity;
            },
             setNewCartQuantity(newQty, variant) {
                if (variant.updatedStatus.maxOrderQuantity < newQty) {
                    variant.newCartQuantity = variant.updatedStatus.maxOrderQuantity
                } else {
                    variant.newCartQuantity = newQty;
                }
            },
            incrimentQuantity(variant) {
                let step = this.resolveVariantStep(variant);
                this.setNewCartQuantity(this.roundToCeiling(variant.newCartQuantity + 1, step), variant);
            },
            decrimentQuantity(variant) {
                let step = this.resolveVariantStep(variant);
                this.setNewCartQuantity(this.roundToFloor(variant.newCartQuantity - 1, step), variant);
            },
            setQuantity(event, variant) {
                let text = event.target.value;
                if (isNaN(text)) {
                    return;
                }
                this.setNewCartQuantity(+text, variant);
                let step = this.resolveVariantStep(variant);
                this.setNewCartQuantity(this.roundToCeiling(+text, step), variant);
            },
            async addToCart(){
                let cartArray = [];

                if(cartArray.length){
                    let updatedCart = await fetch('/cart/update.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        },
                        body: cartArray.join("&")
                      })
                      .then(response => response.text())
                      .then(result => JSON.parse(result))
                      .catch(error => console.log('error', error));
                    
                    //FlipbookProductPopupHelper.processUpdatedCart(updatedCart, product)
                      
                  }else{
                    alert('No change was made to the cart');
                  }
            },
            variantChanged(event){
                let image = this.productData.product.images.find(x=> x.id === this.activeVariant.image_id);
                this.changeMainImage(image);
            },
            iconImageSelected(event, image){
                this.changeMainImage(image);
            },
            changeMainImage(image){
                if(image){
                    this.selectedImage = image.src;
                }
            },
            updateImageBasedOnVariant(){
                if (this.productData && this.activeVariant) {                    
                    if(this.activeVariant?.image_id){
                        let image = this.productData.product.images.find(x=> x.id === this.activeVariant?.image_id);
                        if(image){
                            this.changeMainImage(image);
                        }else{
                            this.changeMainImage(this.productData.product.images[0]);
                        }
                    }else{
                        this.changeMainImage(this.productData.product.images[0]);
                    }
                }
            },
        },
        computed:{            
            option1:function(){
                return this.productData?.product?.options[0];
            },
            option2:function(){
                if(!this.option1SelectedVal){
                    return this.productData?.product?.options.length > 1? this.productData?.product?.options[1]:null;
                }
                //else
                let values = this.productData.product.variants.map(
                    x=> x.option1 == this.option1SelectedVal ? x.option2:""
                )
                .filter(x => x);
                if (!values?.length) {
                    return null;
                }

                if(!values.some(x=> x == this.option2SelectedVal)){
                    this.option2SelectedVal = values[0];
                }
                return {...this.productData?.product?.options[1], values: values };
            },
            option3:function(){
                if(!this.option2SelectedVal){
                    return this.productData?.product?.options.length > 2? this.productData?.product?.options[2]:null;
                }
                //else
                let values = this.productData.product.variants.map(
                    x=> x.option1 == this.option1SelectedVal && x.option2 == this.option2SelectedVal ? x.option3:""
                )
                .filter(x=> x);
                if(!values?.length){
                    return null;
                }
                
                if(!values.some(x=> x == this.option3SelectedVal)){
                    this.option3SelectedVal = values[0];
                }

                
                return {...this.productData?.product?.options[2], values: values };
            }


        }
    });
}

class AccessoriesProductPopupHelper {
    static async updateAccessoriesPopupCart(varinat) {
        //disable


        let formData = {
            'items': [{
            'id': varinat.id,
            'quantity': 1
            }]
        };

        let variantSelects = document.querySelector('variant-selects');
        if(variantSelects){
            formData["section-id"] = variantSelects.getAttribute('data-section');
            formData["sections_url"] = variantSelects.getAttribute('data-url');
            formData["sections"] = "cart-drawer,cart-icon-bubble"
        }
        
        let updatedCart = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        AccessoriesProductPopupHelper.processUpdatedCart(updatedCart)

        
    }
    static processUpdatedCart(updatedCart) {
        let popup = document.querySelector('accessories-product-popup');
        popup.close();
        AccessoriesProductPopupHelper.updateMiniCart(updatedCart); 
    }
    static updateMiniCart(updatedCart){
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        let status = updatedCart.status;
        let error = updatedCart.description;
        if(status === 422){
            alert(error);
            return;
        }

        cart?.renderContents(updatedCart);
        if (cart?.classList.contains('is-empty')) cart?.classList.remove('is-empty');
    }
    
    static async fetchExistingCart() {
        try {
            const response = await fetch("/cart.js", {
                "method": "GET",
                "mode": "cors",
                "credentials": "include"
            });
            const result_1 = await response.text();
            return JSON.parse(result_1);
        } catch (error) {
            return console.log('error', error);
        }
    }

    static dateToString(jsonDate) {
        try {
            var dp = JSON.parse(`\"${jsonDate}\"`);
            var d = new Date(dp);
            return d.toLocaleDateString('en-GB');
        } catch (e) {
            console.log(e);
        }
        return "";
    }

    static fetchProductsApiData() {
        let url = baseApiUrl + "/api/TradeProducts";
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        let raw = JSON.stringify({
            "TradeWebsiteId": "1",
            "SearchTime": new Date()
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        return fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => JSON.parse(result))
            .catch(error => console.log('error', error));
    }

    static getCartQuantity(sku, cart) {
        if (!cart || !cart.items) {
            return 0;
        }

        var filtedItems = cart.items.filter(x => x.sku === sku);
        if (!filtedItems.length) {
            return 0;
        }

        return filtedItems[0].quantity;
    }

    static getVariantStatus(variant, productData) {
        let inventory = productData.inventory.filter(x => x.sku === variant.sku);
        let filteredStatus = productData.status.filter(x => x.Sku === variant.sku);
        let status = (filteredStatus.length > 0) ? filteredStatus[0] :
            {
                "ItemStatusCode": null,
                "DueDate": null,
                "Carton": null,
            }

        let result = {
            dueDateStr: '',
            canOrder: true,
            maxOrderQuantity: Number.MAX_SAFE_INTEGER,
            stock: 0,
            statusClass: '',
            itemStatusCode: status.ItemStatusCode,
            carton: status.Carton
        };
        if (inventory && inventory.length > 0 && inventory[0].quantity > 0) {
            result.stock = inventory[0].quantity;
        }

        if (status.ItemStatusCode != "COLLECTION" && status.DueDate == null) {
            result.maxOrderQuantity = result.stock;
            if (result.stock == 0) {
                result.canOrder = false;
            }
        }

        if (status.DueDate != null) {
            var dateString = dateToString(status.DueDate);
            if (dateString.length > 0) {
                result.dueDateStr = `Due Date: ${dateString}`;
            }
        } else if (inventory == 0) {
            result.dueDateStr = 'Out of Stock';
        }

        if (result.stock > 0) {
            result.statusClass = 'in-stock';
        } else {
            if (status.DueDate != null && status.DueDate != '') {
                result.statusClass = 'due-date';
            } else {
                if (status.ItemStatusCode == "COLLECTION") {
                    result.statusClass = 'due-date';
                } else {
                    result.statusClass = 'out-stock';
                }
            }
        }
        return result;
    }




    static waitCustomerPrice(loadCounter) {
        if (loadCounter < 0)
            return;
        if (typeof CustomerPrice === 'undefined') {
            setTimeout(function () { AccessoriesProductPopupHelper.waitCustomerPrice(--loadCounter); }, 500);
            console.log('CustomerPrice not loaded ' + loadCounter);
            return;
        }
        CustomerPrice.GetPrice().then(function (price) {
            customerPrice = price;
            CustomerPrice.ResolvePrice();
        });
    }

    //method to resolve product handle
    static async resolveProducts(sku) {

        await productDataPromise;
        let apiProduct = allProductData.filter(p => p.sku.startsWith(sku));
        return apiProduct;
    }


    static getProductData(handle) {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        let url = `/products/${handle}.json`;
        return fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => JSON.parse(result))
            .catch(error => console.log('error', error));
    }
    static async processMessageEvent(handle, selectedVariantId) {
        let popup = document.querySelector('accessories-product-popup');
        popup.open("Getting data...");
        let productData = await AccessoriesProductPopupHelper.getProductData(handle);
        let selectedVariant = selectedVariantId? productData.product.variants.find(x=> x.id === selectedVariantId): productData.product.variants[0] ;
        selectedVariant = selectedVariant??productData.product.variants[0];
        popup.setData(productData, selectedVariant, ShopifyAnalytics.meta.currency);
        popup.setStatus('');        
    }
}

class AccessoriesProductPopup extends HTMLElement {
    constructor() {
        super();
    }
    modal = null;
    connectedCallback() {
        this.modal = this.querySelector('.modal');
        this.bindEvents();
    }
    bindEvents() {
        window.onclick = (event) => {
            if (event.target == this.modal) {
                this.close();
            }
        }
        this.querySelector(".close").addEventListener('click', () => this.close())
    }
    open(status) {
        this.modal.style.display = "flex";
        this.setStatus(status);
        document.querySelector('body').classList.add('body-noscroll-class');
    }
    setStatus(status) {
        productVue.setStatus(status)
    }
    setData(productData, selectedVariant, currency) {
        productVue.setMoneyFormat(this.getAttribute('data-money-format'));
        productVue.setCurrency(currency);
        productVue.setProductData(productData, selectedVariant);
        productVue.setDisableButton(false);
    }
    close() {
        this.modal.style.display = "none";
        productVue.setProductData(null, null);
        document.querySelector('body').classList.remove('body-noscroll-class');
    }
}

(function () {
    customElements.define("accessories-product-popup", AccessoriesProductPopup);
})();
setTimeout(()=>{
    let accessoryImages = document.querySelectorAll('dyefor-product-accessories .accessory-image');

    for(const accessoryImage of accessoryImages){
        accessoryImage.addEventListener('click', (event)=>{
            
            let wrap = accessoryImage.closest('.product_accessories_item');
            let accessoryHandle = wrap.getAttribute('data-handle');
            let select = wrap.querySelector('.accessory_select');
            let selectedVariantId = select?+select.value:0;
            if(accessoryHandle){
                AccessoriesProductPopupHelper.processMessageEvent(accessoryHandle, selectedVariantId);
            }

        });
    }
}, 500);

//AccessoriesProductPopupHelper.processMessageEvent(event);